import { isPoetProject } from 'utils';
import { OrderBahnHeader } from './OrderBahnHeader';
import { PoetHeader } from './PoetHeader';

const Header = isPoetProject() ? PoetHeader : OrderBahnHeader;

export default Header;
